import { escapeHTML } from '../../utils/escape.js';

/**
 * Vista "sin acceso" del panel admin (`/admin`) para una sesión `counter`
 * (route rename, owner decision: sin redirects). Se muestra EN EL LUGAR —
 * la URL no cambia y nadie navega a otro lado — con el mensaje y el botón de
 * cerrar sesión, para que el counter pueda entrar con otra cuenta. Es una
 * cortesía de UX, no el límite real (ese sigue siendo RLS/`is_admin()`).
 *
 * Función de render pura: el `data-action="admin-logout"` lo cablea
 * js/admin.js (`setupAdminListeners`), igual que el del shell.
 *
 * @param {string} mensaje — copy del acceso denegado.
 * @returns {string} HTML de la vista.
 */
export const AdminAccessDenied = (mensaje) => `
    <div class="max-w-sm mx-auto" data-admin-access-denied>
        <div class="flex flex-col items-center mb-8">
            <div class="w-14 h-14 rounded-2xl bg-brand/10 flex items-center justify-center mb-5">
                <i class="fa-solid fa-lock text-brand text-xl" aria-hidden="true"></i>
            </div>
            <h2 class="text-2xl font-black uppercase tracking-tight text-text-primary mb-2">Panel Admin</h2>
            <p role="alert" class="text-sm text-text-muted text-center">${escapeHTML(mensaje)}</p>
        </div>
        <button type="button" data-action="admin-logout"
            class="w-full py-5 bg-surface border border-border-subtle text-text-primary rounded-2xl font-black uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:text-brand transition-colors">
            <i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i>
            Cerrar sesión
        </button>
    </div>
`;
